// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { jobsite as baseJobsiteTheme } from "@stepstone-genesis/design-tokens";
var jobsite = extendBaseTheme("jobsite", baseJobsiteTheme);
export {
  jobsite
};
